"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withIconComponent = _interopRequireDefault(require("../../../withIconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AlertCircleExc = function AlertCircleExc() {
  return /*#__PURE__*/_react["default"].createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#404040"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 1a11 11 0 1 0 0 22 11 11 0 1 0 0-22z",
    fill: "none",
    stroke: "#404040",
    strokeLinecap: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 7v6",
    fill: "none",
    stroke: "#FF6400",
    strokeLinecap: "round",
    strokeWidth: "2",
    "data-color": "color-2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 16a1 1 0 1 0 0 2 1 1 0 1 0 0-2z",
    fill: "#FF6400",
    "data-color": "color-2",
    "data-stroke": "none"
  }));
};

var _default = (0, _withIconComponent["default"])("NucleoSmallUserInterfaceAlertCircleExc", false)(AlertCircleExc);

exports["default"] = _default;